
























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import { PatientDetailsViewModel, VentMonitorModel, VentType } from "@/models";
import VentLabel from "./VentLabel.vue";
import VentValue from "./VentValue.vue";
import {
  getVentMonitorFieldDefinitions,
  VentFieldInfo,
  DefaultVentMonitorFields,
  BellavistaVentMonitorFields
} from "./vent-fields";

@Component({
  components: { VentLabel, VentValue }
})
export default class VentMonitor extends Vue {
  @Prop() readonly patient!: PatientDetailsViewModel;

  get fields(): VentFieldInfo<VentMonitorModel>[] {
    let fields = DefaultVentMonitorFields;

    // Bellavista uses a different set of fields than Avea and only includes fields if they have a value
    if (this.isBellavistaType) {
      fields = BellavistaVentMonitorFields.filter(f => !!this.monitor[f] || this.monitor[f] === 0);
    }

    return getVentMonitorFieldDefinitions(fields);
  }

  get monitor() {
    return this.patient.ventMonitor;
  }

  get settings() {
    return this.patient.ventSetting;
  }

  get ventType() {
    return this.settings?.ventTypeKey;
  }

  get isBellavistaType() {
    return this.ventType === VentType.Bellavista;
  }
}
